module.exports = __webpack_public_path__ + "img/show.42bc39b7.png";